import React from "react";

type ColumnCheckboxProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    inputId: string;
    label: string | undefined;
    containerClassName?: string;
    readOnly: boolean;
};

function ColumnCheckbox({
    checked,
    onChange,
    inputId,
    label,
    containerClassName = "",
    readOnly = false
}: ColumnCheckboxProps) {
    return (
        <div className={`d-flex flex-column align-items-center ${containerClassName}`}>
            <label className={`form-check-label fw-bold ${readOnly ? "pe-none" : ""}`} htmlFor={inputId}>
                {label}
            </label>
            <input
                id={inputId}
                type="checkbox"
                className={`form-check-input mt-3 ${readOnly ? "read-only-check" : ""}`}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
            />
        </div>
    );
}

export default ColumnCheckbox;
